<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="loading ? [] : itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
        hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="64">
          <v-container fluid>
            <v-row class="mt-10">
                <v-text-field
                    v-if="userId === null"
                    v-model="searchTerm"
                    label="Search user, employee, department"
                    clearable
                    @input="onUpdateSearchTerm"
                ></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="from_date" clearable label="From" @input="onUpdateFilters()"></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="date" v-model="to_date" clearable label="To" @input="onUpdateFilters()"></v-text-field>
              <v-spacer></v-spacer>
              <v-checkbox
                  v-model="onlyActiveUser"
                  label="only active user"
                  @change="onUpdateFilters"
              ></v-checkbox>
            </v-row>
          </v-container>
        </v-toolbar>
      </template>
      <template v-slot:item.human_user="{ item }">
        {{ item.human_user__user }} ({{ item.human_user__employee_number }})
      </template>
      <template v-slot:item.work_to_be="{ item }">
        {{ getDuration(item.work_to_be) }}
      </template>
      <template v-slot:item.work_as_is="{ item }">
        {{ getDuration(item.work_as_is) }}
      </template>
      <template v-slot:item.over_time="{ item }">
        {{ getDuration(item.over_time) }}
      </template>
      <template v-slot:item.event_start="{ item }">
        <span v-if="item.event_start">
          {{ item.event_start | moment("DD.MM.YYYY HH:mm:ss") }}
        </span>
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';


export default {
  name: 'CalendarDateUserStatisticRange',
  props: {
    subtractHeight: {type: [Number], default: 180},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserStatisticRangeDTO'},
  },

  components: {
  },

  computed: {
    ...mapGetters('CalendarDateUserStatisticRange', ['getColumns']),
    ...mapFields('CalendarDateUserStatisticRange', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
  },

  methods: {
    ...mapActions('CalendarDateUserStatisticRange', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.error_message != null)
        return "event_error"
      else
        return "event_" + item.event
    },

    getEventColor: function (item) {
      return this.local_phrase[item.event].color
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, this.filterEvents, this.startMonth, this.endMonth)
      this.options.page = 1

      this.filters = {}

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      if (this.from_date) {
        console.log('from_date', this.from_date)
        this.filters['from_date'] = this.from_date + " 00:00:00"
      }
      else
        this.filters['from_date'] = null

      if (this.to_date)
        this.filters['to_date'] = this.to_date + " 23:59:59"
      else
        this.filters['to_date'] = null

      if (this.onlyActiveUser === true)
        this.filters['only_active_user'] = true

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),

    getDuration(duration_hours) {
      let abs_duration_hours = Math.abs(duration_hours)
      let hours = Math.floor(abs_duration_hours)
      let minutes = Math.floor(abs_duration_hours * 60) % 60
      if (!duration_hours)
        return '00:00'
      if (duration_hours >= 0)
        return ' ' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
      else
        return '-' + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0')
    },
  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    window.addEventListener("resize", this.onResize)
    this.searchTerm = null
    this.to_date = new Date().toISOString().slice(0, 10)
    this.onUpdateFilters()
    console.log('this.to_date', this.to_date)
  },

  data() {
    return {
      localFilterDate: this.date,
      windowSize: {x: 0, y: 0,},
      userSelected: null,
      filterEvents: [],
      eventsList: ['tracker', 'working', 'pause', 'time_correction', 'holiday', 'holiday_extra', 'sick', 'sick_with_child'],
      errorMessageFilter: false,
      uncheckedFilter: false,
      deletedFilter: false,
      from_date: null,
      to_date: null,
      onlyActiveUser: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
